/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Open_Partner_RecordInputs */



/**
* | output |
* | --- |
* | "open partner record" |
*
* @param {Partner_Billing_Board_Open_Partner_RecordInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_open_partner_record = /** @type {((inputs?: Partner_Billing_Board_Open_Partner_RecordInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Open_Partner_RecordInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Partnerdatensatz öffnen")
	return /** @type {LocalizedString} */ ("open partner record")
});